import * as React from "react";
import { IForm } from "../IForm";
import { AssignPersonActions } from "./AssignPersonActions";
import { AssignPersonStore } from "./AssignPersonStore";
import { Container } from "../../../Container";
import { EditCreateEntityRoute } from "../EditCreate/EditCreateEntityRoute";
import { AssignPerson } from "./AssignPerson";
import { assignPersonRoute, appNavigator } from "../../../routes";
import { SensorsExcessesGrid } from "./SensorsExcessesGrid";
import { SensorExcess, ReportResult, IncidentAssignment } from "../../../../rest/Dashboard/interfaces";
import { requestVehicles, requestSensors } from "../../../../rest/Search";
import { ListStore } from "../../../flux/Grid/ListStore";
import { TableTitle } from "../../Table/TableTitle";
import { LabelStore } from "../../../flux/Label/LabelStore";
import { ReportGrid } from "./ReportGrid";
import { FlagStore } from "../../../flux/Flag/FlagStore";
import { ErrorStore } from "../../../flux/Error/ErrorStore";
import { twoButtonDialogConfig } from "../../../utils/configure-store";
import { ErrorActions } from "../../../flux/Error/ErrorActions";
import {EntityType, Key} from "../../../../models";
import { Polyglot } from "../../../../polyglot";
import { ValueStore } from "../../../flux/Value/ValueStore";
import { ErrorMessage } from "../../../../components/ErrorMessage";
import { StickyMediator } from "../../../utils/StickyMediator";
import { OneButtonDialog } from "../../Dialogs/OneButtonDialog/index";
import { FlagActions } from "../../../flux/Flag/FlagActions";
import { Command, Command1, Command2 } from "../../../../Command";
import {SelectedItemsStore} from "../../../flux/Grid/SelectedItemsStore";
import {SelectedItemsActions} from "../../../flux/Grid/SelectedItemsActions";
import {TrashButtonWidget} from "../../TrashButtonWidget";
import {DeleteConfirmationWidget, DeleteItemsProps} from "../../DeleteConfirmationWidget";

const styles = require('./Home.local.css');
const appStyles = require('../../../app.scss');

export interface Props extends DeleteItemsProps
{
    polyglot: Polyglot;
    loadDashboardCmd: Command;
    searchVehiclesByCategoryInitiator: ValueStore<Key>;
    searchVehiclesByCategory: Command2<Key, any>;
    sensorsExcessesListStore: ListStore<SensorExcess>;
	selectedItemsStore: SelectedItemsStore<SensorExcess>;

    sensorsDataSearchInitiatorStore: ValueStore<Key>;
    sensorsSearchInitiatorStore: ValueStore<Key>;
    vehicleSearchInitiatorStore: ValueStore<Key>;

    reportTableTitleStore: LabelStore;
    reportListStore: ListStore<ReportResult>;

    assignCmd: Command1<IncidentAssignment>;
    assignmentInProgressStore: FlagStore;
    assignmentErrorStore: ErrorStore;

    vehicleSearchCmd: Command2<Key, any>;
    sensorSearchCmd: Command2<Key, any>;
    incidentDataSearchCmd: Command1<Key>;

    excessTableErrorStore: ErrorStore;
    alertStore: FlagStore;
}

export class Dashboard extends React.Component<Props>
{
    private intervalToken: any;
    private formRef: IForm;
    private readonly assignPersonActions = new AssignPersonActions();
    private readonly assignPersonStore = new AssignPersonStore();
    private readonly errorActions = new ErrorActions();

    private readonly stickyMediator = new StickyMediator();

    componentWillMount()
    {
        this.props.loadDashboardCmd.execute();
        this.intervalToken = setInterval(() =>
            {
                var selectedItemsStore = this.props.selectedItemsStore;

                // skip refresh if some items are selected and N seconds have not elapsed
                if (!!selectedItemsStore.lastChange
                    && selectedItemsStore.getState().selected.size > 0
                    && ((new Date () as any) - (selectedItemsStore.lastChange as any)) < 120 * 1000
                    )
                {
                    return;
                }

                this.props.loadDashboardCmd.execute();
            }, 10 * 1000);
    }

    componentWillUnmount()
    {
        clearInterval(this.intervalToken);
    }

    render()
    {
        const { polyglot } = this.props;
        return (
            <div>
				<DeleteConfirmationWidget {...this.props} entityType={EntityType.SensorExcess} title={polyglot.t('dashboard.excess_table.del_confirmation_title')}>
					<span className={appStyles.ConfirmationContainer}>{polyglot.t('dashboard.excess_table.del_confirmation_msg')}</span>
				</DeleteConfirmationWidget>
                {<Container merge stores={twoButtonDialogConfig(this.props.assignmentInProgressStore, this.props.assignmentErrorStore)}>
                    <EditCreateEntityRoute path={assignPersonRoute}
                        title={polyglot.t('dashboard.excess_assignment.title')}
                        okTitle={polyglot.t('button.commit')}
                        cancelTitle={polyglot.t('button.cancel')}
                        renderEdit={() => (
                            <Container store={this.assignPersonStore} actions={this.assignPersonActions}>
                                <AssignPerson polyglot={polyglot} ref={e => this.formRef = e} draft={null} durations={[]} />
                            </Container>
                        )}
                        ok={() => this.props.assignCmd.execute(this.assignPersonStore.getState().draft) }
                        cancel={() => {
                            this.assignPersonActions.reject();
                            appNavigator.goToAlarm();
                        }}>
                    </EditCreateEntityRoute>
                </Container>}

                <OneButtonDialog
                    visibilityStore={this.props.alertStore}
                    title={polyglot.t('misc.info')}
                    okTitle={polyglot.t('button.ok')}
                    ok={() => (new FlagActions()).reset(this.props.alertStore.dispatchToken)}>
                        <div>{polyglot.t('sensor.no_data_msg')}</div>
                </OneButtonDialog>

                {/* <TableTitle polyglot={polyglot} labelStore={this.props.reportTableTitleStore} />
                <Container merge stores={[
                    this.props.reportListStore,
                    [this.props.searchVehiclesByCategoryInitiator, (store: ValueStore<Key>) => ({ searchInitiator: store.getValue() })]
                ]}>
                    <ReportGrid items={[]} searchInitiator={null} polyglot={polyglot} onClick={category => this.props.searchVehiclesByCategory.execute(category, { SummaryCategory: category })} />
                </Container> */}

                <div ref={this.stickyMediator.onToolbox} className={styles.StickyContainer}>
                    <Container store={this.props.excessTableErrorStore}>
                        <ErrorMessage errorMessage={null} />
                    </Container>
                </div>
				<TrashButtonWidget entityType={EntityType.SensorExcess} {...this.props} />
                {<Container merge stores={[
                    this.props.sensorsExcessesListStore,
					this.props.selectedItemsStore,
                    [this.props.sensorsDataSearchInitiatorStore, (store: ValueStore<Key>) => ({ sensorsDataSearchInitiator: store.getValue() })],
                    [this.props.sensorsSearchInitiatorStore, (store: ValueStore<Key>) => ({ sensorsSearchInitiator: store.getValue() })],
                    [this.props.vehicleSearchInitiatorStore, (store: ValueStore<Key>) => ({ vehicleSearchInitiator: store.getValue() })]
                ]}>
                    <SensorsExcessesGrid
                        polyglot={polyglot}
                        sensorsSearchInitiator={null}
                        vehicleSearchInitiator={null}
                        sensorsDataSearchInitiator={null}
                        items={[]}
                        onVehicle={(datum: SensorExcess, row) => this.props.vehicleSearchCmd.execute(datum.IncidentId, { IncidentId: datum.IncidentId })}
                        onSensor={(datum: SensorExcess, row) => this.props.sensorSearchCmd.execute(datum.IncidentId, { IncidentId: datum.IncidentId })}
                        onData={(datum: SensorExcess, row) => this.props.incidentDataSearchCmd.execute(datum.IncidentId)}
                        onAssign={(datum: SensorExcess, row) => {
                            this.assignPersonActions.setSensorExcess(datum);
                            this.errorActions.clearError(this.props.assignmentErrorStore.dispatchToken);
                            appNavigator.goToAssignPersonOnIssuePage();
                        }}
                        onThead={this.stickyMediator.onThead}
                        toggle={(datum: any, row: number) => new SelectedItemsActions().toggleItem(datum.IncidentId, EntityType.SensorExcess)}
                        toggleAll={() => new SelectedItemsActions().toggleAll(EntityType.SensorExcess)}
                    />
                </Container>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Home/Home.tsx